export enum DSpaceObjectType {
  BUNDLE = 'BUNDLE',
  BITSTREAM = 'BITSTREAM',
  ITEM = 'ITEM',
  COLLECTION = 'COLLECTION',
  COMMUNITY = 'COMMUNITY',
  DSPACEOBJECT = 'DSPACEOBJECT',
}
